// @wc-ignore-file

/**
 * The absolute base the assistant appends a document id to when it links a
 * document it created (`<base>/<id>`). Absolute so links surfaced outside the
 * app (Slack posts, emails) point at the real host. CR-162: undefined without
 * both slugs; the api-server then resolves the project-scoped url itself
 * (backend/api-server/src/lib/document-url.ts) and never emits a bare `/docs/:id`.
 */
export function buildDocsBaseUrl(
  slug: string | undefined,
  projectSlug: string | undefined,
  origin: string = typeof window !== "undefined" ? window.location.origin : "",
): string | undefined {
  if (!slug || !projectSlug) return undefined;
  return `${origin}/workspaces/${slug}/projects/${projectSlug}/docs`;
}
